import allCountries from "country-region-data/data.json"
import { SelectItem } from "@mantine/core"

export const countries: SelectItem[] = []
export const regions: Record<string, SelectItem[]> = { "": [] }

const prioritizedOrder = ["CA", "US"]
const prioritized: Record<string, SelectItem> = {}

for (const { countryName, countryShortCode, regions: allRegions } of allCountries) {
  if (prioritizedOrder.includes(countryShortCode))
    prioritized[countryShortCode] = { label: countryName, value: countryShortCode }
  else countries.push({ label: countryName, value: countryShortCode })

  regions[countryShortCode] = allRegions.map((region) => ({
    label: region.name,
    value: region.shortCode ?? region.name,
  }))
}

const prioritizedInsert = []
for (const code of prioritizedOrder) {
  prioritizedInsert.push(prioritized[code])
}
countries.unshift(...prioritizedInsert)

export const regionsName = (countryCode?: string | null) =>
  ({ CA: "Province", US: "State" }[countryCode ?? ""] ?? "Region")
